import PAImage from "component/design-system/images/PAImage";
import withErrorHandler from "component/design-system/withErrorHandler";
import HideIf from "util/HideIf";
import { FC } from "react";
import styles from "./authorInfo.module.scss";

interface IProps {
  authorInformation: {
    persona: string;
  },
  className: string
  hideDescription?: boolean;
  imageClass?: string;
}

const AuthorInfo: FC<IProps> = (props) => {
  const {
    authorInformation, className = "", contentPerosnasJson,
    hideDescription = false, imageClass = "",
  } = props;

  if (!authorInformation?.persona || authorInformation.persona === "NA") {
    return null;
  }

  const authorName = authorInformation?.persona ? contentPerosnasJson[authorInformation.persona].name : "Partsavatar";
  const description = contentPerosnasJson[authorInformation.persona].description || "";

  return (
    <div className={`${styles.main_container} ${className}`}>
      <HideIf show={authorName !== "Partsavatar"}>
        <PAImage
          src={`https://partsavatar.ca/cms/articles-static-page/images/persona/${contentPerosnasJson[authorInformation.persona].url}`}
          width={100}
          height={100}
          alt="persona image"
          className={`m-r-10 ${imageClass}`}
        />
      </HideIf>

      <div className="d-flex flex-column">
        <div className={`m-b-5 ${styles.author_title}`}>
          {authorName}
        </div>
        <div className={`m-b-20 ${styles.persona}`}>
          {authorInformation.persona}
        </div>
        <HideIf show={!hideDescription}>
          <div className={`m-b-10 ${styles.description}`}>
            {description}
          </div>
        </HideIf>

        <div className="d-flex flex-wrap m-b-10">
          {/* {contentPerosnasJson[authorInformation.persona].expertise.split(",").map((eachExpertise: string) => (
            <div className={styles.expertise} key={eachExpertise}>
              {eachExpertise}
            </div>
          ))} */}
        </div>
      </div>

    </div>
  );
};

export default withErrorHandler(AuthorInfo);
